import React, { useMemo } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useEntgeltEmbed } from '../../context/EntgeltEmbedContext';

/**
 * EU-Entgelttransparenz – nur Hauptinhalt im iframe; Navigation liegt in der Portal-Sidebar.
 */
const EntgelttransparenzResource = () => {
  const ctx = useEntgeltEmbed();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const src = useMemo(() => {
    const q = searchParams.toString();
    return q ? `/entgelttransparenz/index.html?${q}` : '/entgelttransparenz/index.html';
  }, [searchParams]);

  const handleLoad = () => {
    ctx?.setEmbedReady?.(true);
    if (location.state?.forceOverview) {
      ctx?.postToEmbed?.({ type: 'et-host-overview' });
    }
    ctx?.postToEmbed?.({ type: 'et-host-request-state' });
  };

  return (
    <div className="w-full flex-1 flex flex-col min-h-0 bg-hrf-navy/[0.04]">
      <iframe
        title="Stellenbeschreibung Assistent (EU-Entgelttransparenz)"
        src={src}
        ref={ctx?.setIframeEl}
        onLoad={handleLoad}
        className="w-full flex-1 min-h-[520px] border-0 block bg-white"
      />
    </div>
  );
};

export default EntgelttransparenzResource;
